export default {
  title: 'Geschäftsinformationen',
  form: {},
  buttons: {
    save: 'Speichern',
  },
  toasts: {
    success: 'Deine Informationen wurden erfolgreich gespeichert.',
  },
};
